<div class="event-page" [class.has-sticky-actions]="showStickyActions">
  <div class="page-sub-title">{{ league?.eventName }}</div>

  <div class="sub-nav-wrapper event-nav" *ngIf="containerDisplay !== 'CREATETEAM' && containerDisplay !== 'CREATE' && containerDisplay !== 'EDITWEEK'">
    <div class="sub-nav">
      <div class="sub-nav-item" [class.active]="containerDisplay === 'LEADERBOARD'" (click)="showLeaderboard()">Leaderboard</div>
      <div class="sub-nav-item" [class.active]="isPlayTabActive" (click)="showPlaySection()">{{ playTabLabel }}</div>
      <div class="sub-nav-item" [class.active]="containerDisplay === 'FIELD'" (click)="showField()">Field</div>
      <div class="sub-nav-item" [class.active]="containerDisplay === 'INFO'" (click)="showInfo()">Info</div>
    </div>
  </div>

  <div *ngIf="containerDisplay === 'LEADERBOARD'">
    <app-league-leaderboard [league]="league"></app-league-leaderboard>
  </div>

  <div id="week-list-container" *ngIf="containerDisplay === 'WEEKLIST'">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th class="center">{{ scheduleColumnLabel }}</th>
              <th>Course</th>
              <th class="hide-on-mobile">Holes</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let week of leagueWeeks; let i = index" (click)="selectWeek(week)">
              <td class="center narrow">
                {{ isMultiWeekLeague ? (leagueWeeks.length - i) : (i + 1) }}
              </td>
              <td>
                {{ week.golfCourseName }}
                <div class="course-holes hide-on-desktop">{{ formatHolesToPlay(week.holesToPlay) }}</div>
              </td>
              <td class="hide-on-mobile">
                {{ formatHolesToPlay(week.holesToPlay) }}
              </td>
            </tr>
          </tbody>
          </table>
      </div>

      <div *ngIf="canManageSlots">
          <button (click)="containerDisplay = 'CREATE'">{{ addSlotLabel }}</button>
      </div>
  </div>

  <div id="week-info-container" *ngIf="containerDisplay === 'WEEKINFO'" class="table-container">
      <button
        type="button"
        class="back-link"
        *ngIf="!isSingleCourse"
        (click)="containerDisplay = 'WEEKLIST'">
        Back
      </button>
      <div class="page-sub-title course-title">{{ selectedWeek?.golfCourseName }}</div>
      <div>
          <app-weekly-round-list
            [league]="league"
            [leagueWeek]="selectedWeek"
            [loggedInPlayerHasPaid]="hasPaidEntryFee"
            [loggedInPlayerId]="loggedInPlayerId"
            [paidPlayers]="paidPlayers"
            [openPostTrigger]="openPostTrigger"
            [hidePostButton]="true"
            (editWeek)="editWeek($event)"
            (postingChange)="onPostingChange($event)">
          </app-weekly-round-list>
      </div>
  </div>

  <div id="field-container" *ngIf="containerDisplay === 'FIELD'">
    <app-field [league]="league"></app-field>
  </div>

  <div id="info-container" *ngIf="containerDisplay === 'INFO'">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th colspan="2" class="center">Event Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Dates</td>
            <td>{{ formatDate(league?.startDate) }} – {{ formatDate(league?.endDate) }}</td>
          </tr>
          <tr>
            <td>Entry Fee</td>
            <td>${{ league?.entryFee }}</td>
          </tr>
          <tr>
            <td>Format</td>
            <td>{{ formatLabel }}</td>
          </tr>
          <tr>
            <td>Scoring</td>
            <td>{{ scoringLabel }}</td>
          </tr>
          <tr *ngIf="isHybridScramble">
            <td>Pairing</td>
            <td>2 man scramble, pick any field partner or guest each round</td>
          </tr>
          <tr *ngIf="!isHybridScramble">
            <td>Team Event</td>
            <td>{{ formatYesNo(league?.isTeamEvent) }}</td>
          </tr>
          <tr>
            <td>Handicaps</td>
            <td>{{ formatYesNo(league?.useHandicaps) }}</td>
          </tr>
          <tr *ngIf="league?.description">
            <td colspan="2">{{ league?.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngFor="let week of leagueWeeks" class="info-course-block">
      <app-week-details
        [leagueWeek]="week"
        [league]="league"
        [canEdit]="canAddWeek && !isEventOver"
        (edit)="editWeek(week)">
      </app-week-details>
    </div>
  </div>

  <div id="create-week-container" *ngIf="containerDisplay === 'CREATE'">
      <app-create-week [golfEventId]="eventId" [formatType]="formatType" [eventStartDate]="eventStartDateInput" [eventEndDate]="eventEndDateInput" (saved)="refreshWeeks()"></app-create-week>
  </div>

  <div id="edit-week-container" *ngIf="containerDisplay === 'EDITWEEK'">
      <app-create-week [golfEventId]="eventId" [formatType]="formatType" [eventStartDate]="eventStartDateInput" [eventEndDate]="eventEndDateInput" [weekToEdit]="weekBeingEdited" (saved)="refreshWeeks()" (canceled)="containerDisplay = (isSingleCourse || selectedWeek) ? 'WEEKINFO' : 'WEEKLIST'"></app-create-week>
  </div>

  <app-create-team *ngIf="containerDisplay==='CREATETEAM'" [league]="league" [paidPlayers]="paidPlayers" (canceled)="showField()" (saved)="showField()"></app-create-team>

  <div class="sticky-actions" *ngIf="showStickyActions">
    <div class="sticky-message error" *ngIf="!hasPaidEntryFee && isTeamEvent">
      Pay your entry fee before creating or joining a team.
    </div>
    <div class="sticky-message error" *ngIf="!hasPaidEntryFee && !isTeamEvent">
      Pay your entry fee before posting scores.
    </div>
    <div class="sticky-buttons">
      <a class="button" href="{{paymentLink}}" target="_blank" *ngIf="!hasPaidEntryFee">Pay Entry Fee</a>
      <button *ngIf="hasPaidEntryFee && isTeamEvent" (click)="containerDisplay = 'CREATETEAM'">Create a Team</button>
      <button *ngIf="hasPaidEntryFee" (click)="requestPostScore()">Post a Round</button>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showCoursePicker" (click)="closeCoursePicker()">
    <div class="modal-sheet" (click)="$event.stopPropagation()">
      <div class="modal-title">{{ coursePickerTitle }}</div>
      <button
        type="button"
        class="modal-option"
        *ngFor="let week of leagueWeeks"
        (click)="openPostForWeek(week)">
        {{ week.golfCourseName }}
      </button>
      <button type="button" class="cancel modal-cancel" (click)="closeCoursePicker()">Cancel</button>
    </div>
  </div>
</div>
